// Builds display URLs for images stored at STABLE public URLs — a per-entity
// base directory (e.g. user-avatars/{userId}, org logo dir) with size variants
// beneath it. Replacing the image keeps the exact same URL, so a re-render
// alone never makes the browser re-request it and the old image stays on
// screen. Every render site goes through here so a bump (after upload)
// changes the src for the whole session at once.

// Version per asset base URL. Module-scope: one map for the whole session.
const assetVersions = reactive(new Map<string, number>())

export function stableAssetSrc(
  baseUrl: string | null | undefined,
  size: number,
): string | undefined {
  if (!baseUrl) return undefined
  const version = assetVersions.get(baseUrl)
  return `${baseUrl}/${size}.webp${version ? `?v=${version}` : ''}`
}

// Called after a successful upload: rendered `<img>`s get a new versioned src
// immediately, and the UNversioned variant URLs (what a fresh page load uses,
// once this in-memory map is gone) are re-fetched past the browser's HTTP
// cache so they're up to date too. `sizes` = the variants the app renders for
// this asset type.
export function bumpStableAssetVersion(baseUrl: string, sizes: number[]) {
  assetVersions.set(baseUrl, Date.now())
  for (const size of sizes) {
    // no-cors + include mirrors how `<img>` requests these URLs — a bare
    // fetch would be cache-keyed as cors/same-origin and could refresh a
    // DIFFERENT cache entry than the one rendered images read (or reject on
    // CORS entirely), silently making this prefetch a no-op.
    fetch(`${baseUrl}/${size}.webp`, {
      cache: 'reload',
      mode: 'no-cors',
      credentials: 'include',
    }).catch(() => {})
  }
}
